"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var StyledIconButton_1 = require("./StyledIconButton");
var Icon_1 = require("../Icon");
var IconButton = react_1.default.forwardRef(function (_a, ref) {
    var onClick = _a.onClick, label = _a.label, iconProps = _a.iconProps, props = tslib_1.__rest(_a, ["onClick", "label", "iconProps"]);
    return (react_1.default.createElement(StyledIconButton_1.StyledIconButton, tslib_1.__assign({ "aria-label": label, onClick: onClick, ref: ref }, props),
        react_1.default.createElement(Icon_1.Icon, tslib_1.__assign({ "aria-hidden": true }, iconProps))));
});
exports.default = IconButton;
//# sourceMappingURL=IconButton.js.map